module.exports = __webpack_public_path__ + "static/media/Japanese_Tamaki BG-33.cdf23847.png";